import { BreOrderType } from '~/tenants/bre/model/enums';

const BaseRate = {
  BASELINE: '100',
  CAD_FILE: '125',
  FLOORPLAN_3D: '100',
  GLA_REPORT: '50',
  INTERACTIVE_TOUR: '50',
  MIN_RATE: '100',
  RUSH: '50',
  STANDALONE: '75',
  SQFT: '0.025',
};

export const BreFloorplanRate: Record<BreOrderType, typeof BaseRate> = {
  [BreOrderType.COMMERCIAL]: {
    ...BaseRate,
    MIN_RATE: '130',
    SQFT: '0.03',
  },
  [BreOrderType.RENTAL]: BaseRate,
  [BreOrderType.LONG_TERM]: BaseRate,
  [BreOrderType.RESIDENTIAL]: BaseRate,
  [BreOrderType.PROPERTY_MKTG]: BaseRate,
  [BreOrderType.AGENT_MKTG]: BaseRate,
};

const BasePay = {
  BASELINE: '5',
  MIN_PAY: '35',
  STANDALONE: '50',
  SQFT: '0.01',
};

export const BreFloorplanPay: Record<BreOrderType, typeof BasePay> = {
  [BreOrderType.COMMERCIAL]: {
    ...BasePay,
    BASELINE: '-14',
    MIN_PAY: '46',
    SQFT: '0.02',
  },
  [BreOrderType.RENTAL]: BasePay,
  [BreOrderType.LONG_TERM]: BasePay,
  [BreOrderType.RESIDENTIAL]: BasePay,
  [BreOrderType.PROPERTY_MKTG]: BasePay,
  [BreOrderType.AGENT_MKTG]: BasePay,
};
